module.exports = __webpack_public_path__ + "static/media/quick-start-lp.71ddb4e6.svg";